import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@app/core/auth/services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private authService: AuthService) {}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next
			.handle(req)
			.pipe(
				catchError((event: HttpEvent<any>) => this._handleError(event))
			);
	}

	private _handleError(event: HttpEvent<any>): Observable<HttpEvent<any>> {
		if (event instanceof HttpErrorResponse) {
			switch (event.status) {
				case 401:
					this.authService.emitApiUnauthorizedEvent();
					break;
				case 500:
				case 404:
					break;
			}
		}
		return throwError(() => event);
	}
}
